import ParentsAPI from '@/api/parents'
import { base as mutations } from '../types/mutation-types'
import { parents as actions } from '../types/action-types'
import { parseUserData } from '@/util/index'

export default {
  namespaced: true, // -> parents
  state: {
    loading: false,
    error: null,
    alerts: null
  },
  getters: {
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    }
  },
  mutations: {
    [mutations.REQUEST] (state) {
      state.loading = true
      state.error = null
    },
    [mutations.SUCCESS] (state, payload = {}) {
      if (payload.alerts !== undefined) {
        state.alerts = payload.alerts
      }
      state.loading = false
      state.error = null
    },
    'ALERTS' (state, data) {
      state.alerts = data
    },
    [mutations.ERROR] (state, error) {
      state.loading = false
      state.error = error
    }
  },
  actions: {
    [actions.PARENTS_FIND] ({commit}, id) {
      commit(mutations.REQUEST)
      return ParentsAPI.show(id)
                     .then(response => {
                       commit(mutations.SUCCESS)
                       return parseUserData(response.data)
                     })
                     .catch(error => {
                       commit(mutations.ERROR, error)
                       return Promise.reject(error)
                     })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/parents.js